import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

import 'jquery/dist/jquery.min.js';
//Datatable Modules
import 'datatables.net'
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery'

const Userlist = () => {

    const [users, setUsers] = useState([])
    axios.defaults.withCredentials = true;

    const getUsers = async () => {
        const response = await axios.get('https://ayres-iot-backend.cyclic.app/users');
        setUsers(response.data)
    }

    const deleteUser = async (userId) => {
        await axios.delete(`https://ayres-iot-backend.cyclic.app/users/${userId}`)
        getUsers();
    }

    useEffect(() => {
        setTimeout(() => {
            $('#usersData').DataTable().destroy();
            getUsers();
        }, 2000);
    }, []);


    useEffect(() => {
        $('#usersData').DataTable(
            {
                pagingType: 'full_numbers',
                bLengthChange: false,
                processing: true,
                dom: 'Bfrltip',
                lengthMenu: [
                    [10, 25, 50, -1],
                    ['10 rows', '25 rows', '50 rows', 'Show all'],
                ],
                buttons: [
                    {
                        //Tombol untuk Memilih Berpa Banyak Data yang Ditampilkan dalam 1 Halaman
                        extend: 'pageLength',
                        className: 'button is-success is-small is-rounded',
                    },
                    {
                        extend: 'excelHtml5',
                        text: 'Export to Excel',
                        className: 'button is-success is-small is-rounded',
                        titleAttr: 'XLSX',
                        exportOptions: {
                            columns: [1, 2, 3]
                        }
                    },

                ],
                bDestroy: true,
                responsive: true,

            }
        );
    }, [users]);


    return (
        <div>
            <section className="hero is-info welcome is-small">
                <div className="hero-body">
                    <div className="container">
                        <h1 className="title">
                            Users
                        </h1>
                        <h2 className="subtitle">
                            List of Users
                        </h2>
                    </div>
                </div>
            </section>
            <Link to="/users/add" className='button is-success my-5'>Add New</Link>

            <div className='box'>

                <table className='table is-striped is-fullwidth' id='usersData'>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Name</th>
                            <th>Username</th>
                            <th>Role</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, index) => (
                            < tr >
                                <td>{index + 1}</td>
                                <td>{user.name}</td>
                                <td>{user.username}</td>
                                <td>{user.role}</td>
                                <td><Link to={`/users/edit/${user.uuid}`} className="button is-small is-success is-rounded mr-2 mt-2">Edit</Link>
                                    <button onClick={() => deleteUser(user.uuid)} className="button is-small is-danger is-rounded my-2">Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Userlist